import { Grid } from '@material-ui/core';
import React from 'react';
import { EJRecordTypes } from 'src/common/enumerations/ej-record-types';
import { IElectronicJournalRecord } from '../../../common/interfaces/states/IElectronicJournalRecord';
import { styles } from './summary-menu-styles';
import { SvgPromotionsStar, SvgRewardAsTender } from 'src/item-list/components/item-list-icons';
import { useTranslation } from 'react-i18next';

export const PromotionSummaryList: React.FC<SummaryListProps> = ({ item, index }): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();

  return (
    <>
      <Grid container item xs={9} className={classes.containerStyle}>
        <Grid item data-testid={'cart-item-indicator'}>
          {item.Type === EJRecordTypes.RewardAsTender ? (
            <SvgRewardAsTender className={`${classes.iconStyle} ${classes.iconColor}`} />
          ) : (
            <SvgPromotionsStar className={classes.iconStyle} />
          )}
        </Grid>
        <Grid item className={classes.promotionLines} data-testid={`cart-item-name-${index}`}>
          {t(item.Description || item.Name)}
        </Grid>
      </Grid>
      <Grid
        item
        container
        xs={3}
        className={`${classes.promotionLines} ${classes.additionalStyle}`}
        data-testid={`cart-item-price`}
      >
        {item.Price}
      </Grid>
      <div className={classes.promotionLineSeparator}></div>
    </>
  );
};
interface SummaryListProps {
  item: IElectronicJournalRecord;
  index: number;
}
